import clsx from 'clsx'
import { NavLink, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import { reactSelectStyles, reactSelectTheme } from '../utils/reactSelect'

interface PageNavProps {
  navigation: {
    name: string
    href: string
  }[]
}

const PageNav = ({ navigation }: PageNavProps) => {
  const navigate = useNavigate()

  return (
    <div className="mb-10">
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        <Select
          styles={reactSelectStyles}
          theme={reactSelectTheme}
          options={navigation.map((tab) => ({
            value: tab.href,
            label: tab.name,
          }))}
          onChange={(selected: any) => navigate(selected.value)}
        />
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {navigation.map((tab) => (
              <NavLink
                key={tab.name}
                to={tab.href}
                end
                className={({ isActive }) =>
                  clsx({
                    'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300':
                      true,
                    'text-brand-600 border-b-2 border-brand-600': isActive,
                  })
                }
              >
                {tab.name}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
    </div>
  )
}

export default PageNav
